// extracted by mini-css-extract-plugin
module.exports = {"root":"root-391ZX","icon":"icon-1cstF"};